'use client';

import { windowService } from '@/services/jupiter/window-service';
import { useEffect } from 'react';

export const WindowProvider = () => {

	useEffect(() => {
		const handleBeforeUnload = () => {
			windowService.closeAllWindows();
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
			windowService.closeAllWindows();
		};
	}, []);

	return null;
};